<template>
    <button type="button" class="d-none" data-toggle="modal" data-target=".createFileModals" id="addFileBtn"> </button>
    <div class="modal fade bd-example-modal-xl createFileModals" id="folderModalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class=" modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">New Files</h5>
                    <button type="button" class="close" id="closeFilePop" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group col-md-12">
                        <file-pond
                            name="file"
                            ref="pond"
                            v-model="file"
                            :server="getServerConfig()"
                            :allow-multiple="true"
                            :files="myFiles"
                            :instant-upload="true"
                            :max-files="5"
                            label-idle="Drop files here or <span class='filepond--label-action'>Browse</span>"
                        />
                            <!-- :accepted-file-types="['image/jpeg', 'image/png', 'application/pdf', 'application/zip']" -->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="d-none" data-dismiss="modal" id="modalcloseBtn">Close</button>
                    <button type="button" class="btn btn-secondary" v-on:click="modalImgClose">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {
    decodeTextFromBase62,
} from '../../utils/helper.js'
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview
);
export default {
    name: 'CreateFileData',
    data() {
        return {
            errorMessage: '',
            formLoader: 1,
            file: [], // Holds uploaded files
            files: [],
            myFiles: [],
            pond: null,
            form: {
                folderName: '',
            },
        }
    },
    components: {
            FilePond,
        },
    methods: {
        decodeTextFromBase62,
        updateFiles(newFiles) {            
            this.files = newFiles.map((file) => file.file);
        },
        async modalImgClose() {
            this.$store.state.isModalImgOpen = 1;
            document.getElementById('modalcloseBtn').click();
        },
        async createFile() {            
         
            if (this.$refs.pond) {
                this.$refs.pond.removeFiles();
            }
            this.$store.state.isModalImgOpen = 2;
            document.getElementById('addFileBtn').click();
        },
        getServerConfig() {
            return {
                process: (fieldName, file, metadata, load, error, progress, abort) => {

                    var folderName = '';
                    let Folderpaths = ''
                    if (!this.$route.query.path || this.$route.query.path.trim() === '') {
                        // Folderpaths = folderName;
                        Folderpaths = '';
                    }else{
                        // Folderpaths = this.decodeTextFromBase62(this.$route.query.path);
                        // Folderpaths = Folderpaths+ '/' + folderName;

                        const pathParam = this.$route.query.path;

                        if (pathParam) {
                            const pathSegments = pathParam.split('/');

                            let newUrl = '';
                            let newAxiosUrl = '';
                            for (let i = 0; i < pathSegments.length; i++) {
                                let tempName = this.decodeTextFromBase62(pathSegments[i]);
                                if( i === 0) {
                                    newUrl = tempName;
                                    newAxiosUrl = tempName;

                                } else{
                                    newUrl = newUrl + '/' + tempName
                                    newAxiosUrl = newAxiosUrl + '/' + tempName
                                }
                            }
                            Folderpaths = newAxiosUrl;
                        } else {
                            Folderpaths = this.decodeTextFromBase62(this.pathParam);
                        }

                        Folderpaths = Folderpaths+ '/' + folderName;

                        
                        
                    }
                    (async () => {
                        const _URL = process.env.VUE_APP_API_URL + 'files/upload-to-folder';
                        
                        // Set token header
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken
                        const formData = new FormData()
                        formData.append('file', file) 
                        formData.append('folderName', Folderpaths)
                        try {
                            const resp = await axios.post(_URL, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                },
                                onUploadProgress: (e) => {
                                    progress(e.lengthComputable, e.loaded, e.total)
                                }
                            })

                            if (resp.status === 200 && resp.data.status === 'success') {
                                this.$toast.success(resp.data.message)
                                // this.$store.state.home.reLoadFolder = Math.random();
                                // this.$store.state.home.reLoadPathFolder = Math.random();
                                this.$store.state.home.reLoadFilecomponent = Math.random();
                                load(resp.data.fileId || 'ok')
                            } else if (resp.status === 200 && resp.data.status === 'failure') {
                                error(resp.data.message)
                            }
                        } catch (err) {
                            console.error("Upload error:", err)
                            if (err.response) {
                                console.log("Status:", err.response.status)
                                console.log("Message:", err.response.data.message)
                                error(err.response.data.message)
                            } else {
                                error(err.message)
                            }
                        }
                    })()

                return {
                    abort: () => {
                    console.log('Upload aborted')
                    abort()
                    }
                }
                }
            }
        }

    },
}
</script>


<style scoped>
::v-deep(.filepond--credits) {
  display: none !important;
}

::v-deep(.filepond--root) {
  max-height: 250px;
  overflow-y: auto;
}

/* Remove or adjust this only if necessary */
::v-deep(.filepond--drop-label) {
  min-height: 100px;
}
::v-deep(.filepond--item) {
    width: 25%;
}
::v-deep(.filepond--action-revert-item-processing) {
    display: none !important;
}
::v-deep(.filepond--file-status-sub) {
  display: none !important;
}
</style>